
import MyPublicProfile from "@dana/Components/MyProfile/MyPublicProfile";
import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import loadMyProfile from "@dana/Store/Data/MyProfile/Handlers/GetMyProfileHandler";
import loadMyPublicProfile from "@dana/Store/Data/MyPublicProfile/Handlers/GetMyPublicProfileHandler";
import Zone from "@insite/client-framework/Components/Zone";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationStateDana) => {
    const session = getSession(state);
    const { shipToId, properties } = session;
    const shipToState = getShipToState(state, shipToId);
    const { value: shipTo } = shipToState;

    const soldAdrr = (properties?.soldToAddress && properties?.soldToAddress !== "" && properties?.soldToAddress !== undefined) ? JSON.parse(properties?.soldToAddress) : null;
    const selectedCustomer = soldAdrr != null && soldAdrr?.id ? soldAdrr : shipTo;

    return {
        myPublicProfileState: state.myPublicProfileState,
        session: getSession(state),
        customer: selectedCustomer
    }
};

export interface MyProfilePageStyles {
    page?: MobiusPageProps;

}

export const myProfilePageStyles: MyProfilePageStyles = {
    page: {
        background: themeBackgrounds.offWhite,
        fullWidth: [true, true, true, true, true],
    },
};

const mapDispatchToProps = {
    loadMyPublicProfile,
};

type Props = ResolveThunks<typeof mapDispatchToProps> & PageProps & ReturnType<typeof mapStateToProps>;
const styles = myProfilePageStyles;
const MyPublicProfilePage: React.FC<Props> = ({ id, customer, loadMyPublicProfile, myPublicProfileState, session }) => {
    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {
        if (session.userName && customer) {         
            loadMyPublicProfile({ userName: session?.userName, customerId: customer?.id });
            setIsLoading(myPublicProfileState.isLoading);
        }

    }, [session, customer]);


    return (
        <Page {...styles.page}>
            <LoadingOverlay loading={isLoading} >
                {/* <Zone contentId={id} zoneName="Content" /> */}
                <MyPublicProfile></MyPublicProfile>
            </LoadingOverlay>
        </Page>
    );
}

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MyPublicProfilePage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "MyPublicProfilePage" instead of this constant.
 */
export const MyPublicProfilePageContext = "MyPublicProfilePage";
